import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

/**
 * 인기 상품 정보 스키마 (Primitive 중심)
 */
export const PopularProductSchema = z.object({
  goodsNo: z.number().int().describe('상품 번호'),
  goodsName: z.string().describe('상품명'),
  brandName: z.string().describe('브랜드명'),
  imageUrl: z.string().describe('이미지 URL'),
  linkUrl: z.string().describe('상품 링크 URL'),
  price: z.number().describe('판매 가격'),
  salesRate: z.number().describe('할인율 (%)'),
  isLiked: z.boolean().describe('좋아요 여부'),
});

/**
 * 인기 상품 목록 응답 스키마
 */
export const PopularProductsResponseSchema = z.object({
  // 페이징 처리를 위한 리스트 구조
  list: z.array(PopularProductSchema).max(10),
});
/**
 * TypeScript 타입 정의
 */
export type PopularProduct = z.infer<typeof PopularProductSchema>;
export type PopularProductsResponse = MusinsaStandardResponse<
  z.infer<typeof PopularProductsResponseSchema>
>;
